var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5875 3.21751L14.2008 6.44418C14.4208 6.89335 15.0075 7.32418 15.5025 7.40668L18.4266 7.89251C20.2966 8.20418 20.7366 9.56085 19.3891 10.8992L17.1158 13.1725C16.7308 13.5575 16.52 14.3 16.6391 14.8317L17.29 17.6458C17.8033 19.8733 16.6208 20.735 14.65 19.5708L11.9091 17.9483C11.4141 17.655 10.5983 17.655 10.0941 17.9483L7.35329 19.5708C5.39163 20.735 4.19996 19.8642 4.71329 17.6458L5.36413 14.8317C5.48329 14.3 5.27246 13.5575 4.88746 13.1725L2.61413 10.8992C1.27579 9.56085 1.70663 8.20418 3.57663 7.89251L6.50079 7.40668C6.98663 7.32418 7.57329 6.89335 7.79329 6.44418L9.40663 3.21751C10.2866 1.46668 11.7166 1.46668 12.5875 3.21751Z",
    stroke: "#979797",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon);
export default __webpack_public_path__ + "static/media/featureIcon.4f409e697cd2de828bd7dd039339da17.svg";
export { ForwardRef as ReactComponent };